export enum ConsentExperienceType {
  Banner = 'banner',
  Modal = 'modal',
}
